import { getTextUnderlineTemplate } from "../../shortcodes/templates";
import { addShortcodeToEditor, getShortcodeWrapper } from "@/assets/utilities/tinymce/shortodeAddition";
import { parseToHtml } from "@/utility/parseToHtml";
import { TEXT_UNDERLINE_EVENT_TYPES } from "@/constant";

const DATA_ATTR = "data-text-underline-data";

const defaultData = {
  text: '<p style="font-size: 12px; color: #2454C7;">BENEFIT #1</p>',
  lineColor: "#2454C7",
  lineWeight: 2,
  lineLength: 140,
  alignment: "left",
};

const encodeData = data => btoa(unescape(encodeURIComponent(JSON.stringify(data))));

const decodeData = encoded => {
  if (!encoded) return {};

  try {
    return JSON.parse(decodeURIComponent(escape(window.atob(encoded))));
  } catch (error) {
    return {};
  }
};

const normalizeLoadedData = encoded => {
  const data = { ...defaultData, ...decodeData(encoded) };

  return {
    text: data.text || defaultData.text,
    lineColor: data.lineColor || defaultData.lineColor,
    lineWeight: Number(data.lineWeight) || defaultData.lineWeight,
    lineLength: Number(data.lineLength) || defaultData.lineLength,
    alignment: data.alignment || defaultData.alignment,
  };
};

const persistMarkup = (shortcodeWrapper, data) => {
  shortcodeWrapper.setAttribute(DATA_ATTR, encodeData(data));
  const box = shortcodeWrapper.querySelector(".text-underline");
  const markup = getTextUnderlineTemplate(data);

  if (box) {
    box.outerHTML = markup;
  } else {
    shortcodeWrapper.insertAdjacentHTML("beforeend", markup);
  }
};

const textUnderlineConfig = (tinymce, uuid, shortcodeOnClick) => {
  let currentData = null;
  let isValid = null;

  const textUnderlineWindow = tinymce.activeEditor.windowManager.openUrl({
    title: "Text Underline",
    url: "/text-underline-dialog",
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "custom",
        name: "submit",
        text: "Add",
        primary: true,
      },
    ],
    onAction: function (instance) {
      if (!isValid || !currentData) {
        textUnderlineWindow.sendMessage({
          type: TEXT_UNDERLINE_EVENT_TYPES.NEED_VALIDATION,
          data: true,
        });

        return;
      }

      const shortcodeWrapper = getShortcodeWrapper(
        uuid,
        shortcodeOnClick,
        getTextUnderlineTemplate(currentData),
        "text-underline",
      );
      const shortcodeWrapperEl = parseToHtml(shortcodeWrapper).querySelector(".shortcode");
      shortcodeWrapperEl.setAttribute(DATA_ATTR, encodeData(currentData));
      addShortcodeToEditor(shortcodeWrapperEl.outerHTML, uuid, undefined, undefined, false);

      instance.close();
    },
    onMessage: (instance, message) => {
      if (message.mceAction === TEXT_UNDERLINE_EVENT_TYPES.REQUEST_DATA) {
        textUnderlineWindow.sendMessage({
          type: TEXT_UNDERLINE_EVENT_TYPES.SEND_DATA,
          data: "undefined",
        });
      }

      if (message.mceAction === TEXT_UNDERLINE_EVENT_TYPES.UPDATE_TEXT_UNDERLINE_DATA) {
        currentData = message.data;
        isValid = true;
      }

      if (message.mceAction === TEXT_UNDERLINE_EVENT_TYPES.VALIDATION) {
        isValid = message.data.isValid;
      }
    },
    width: 600,
    height: 640,
  });
};

const editTextUnderlineConfig = (editor, shortcodeWrapper) => {
  let currentData = normalizeLoadedData(shortcodeWrapper.getAttribute(DATA_ATTR));
  let isValid = null;

  const textUnderlineWindow = editor.windowManager.openUrl({
    title: "Text Underline",
    url: "/text-underline-dialog",
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "custom",
        name: "submit",
        text: "Save",
        primary: true,
      },
    ],
    onAction: function (instance) {
      if (!isValid || !currentData) {
        textUnderlineWindow.sendMessage({
          type: TEXT_UNDERLINE_EVENT_TYPES.NEED_VALIDATION,
          data: true,
        });

        return;
      }

      persistMarkup(shortcodeWrapper, currentData);
      editor.fire("change");
      instance.close();
    },
    onMessage: (instance, message) => {
      if (message.mceAction === TEXT_UNDERLINE_EVENT_TYPES.REQUEST_DATA) {
        sendData();
      }

      if (message.mceAction === TEXT_UNDERLINE_EVENT_TYPES.UPDATE_TEXT_UNDERLINE_DATA && message.data) {
        currentData = message.data;
        isValid = true;
      }

      if (message.mceAction === TEXT_UNDERLINE_EVENT_TYPES.VALIDATION) {
        isValid = message.data.isValid;
      }
    },
    width: 600,
    height: 640,
  });

  const sendData = () => {
    textUnderlineWindow.sendMessage({
      type: TEXT_UNDERLINE_EVENT_TYPES.SEND_DATA,
      data: normalizeLoadedData(shortcodeWrapper.getAttribute(DATA_ATTR)),
    });
  };
};

export { textUnderlineConfig, editTextUnderlineConfig };
